import React from 'react'
import PropTypes from 'prop-types'
import {
  BOOK_LIST_TYPES,
  BUTTON_SIZE,
  CARD_SIZES,
  COLORS,
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import { getSubjectBackgroundClass } from '@helpers/subject'
import Container from '@components/Container'
import BookCard from '@components/BookCard'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import Divider from '@components/Divider'
import { anySectionHasQuizExams } from '@helpers/exams'

const FeaturedBook = (props) => {
  const { heading, text, book, reversed } = props
  const { id, subject, sections } = book
  const bgClass =
    subject && getSubjectBackgroundClass(subject.slug, 'blockBackground')
  const buttonBgColor =
    subject && getSubjectBackgroundClass(subject.slug, 'dark')

  const wrapperClass = reversed ? 'flex flex-row-reverse' : 'flex flex-row'
  const contentClass = reversed ? 'grow pr-12' : 'grow pl-12'

  const hasQuizExams = anySectionHasQuizExams(sections)

  return (
    <div className={`w-full py-14 ${bgClass}`}>
      <div className={'max-w-screen-lg mx-auto'}>
        <Container size={CONTAINER_STYLE.DESKTOP} paddingTop={false}>
          <div className={wrapperClass}>
            <div className={'basis-[420px] shrink-0 -mt-24'}>
              <BookCard
                book={book}
                size={CARD_SIZES.LARGE}
                listType={BOOK_LIST_TYPES.LIBRARY}
                hasQuizExams={hasQuizExams}
              />
            </div>

            <div className={contentClass}>
              {heading && (
                <Heading
                  headingLevel={HEADING_TYPE.H2}
                  size={TEXT_SIZES.XLARGE}
                >
                  {heading}
                </Heading>
              )}
              {text && (
                <div className='max-w-[600px]'>
                  <Text>{text}</Text>
                </div>
              )}

              <Divider size={DIVIDER_SIZE.SMALL} />

              <Button
                backgroundColor={buttonBgColor}
                textColor={COLORS.WHITE.TEXT}
                size={BUTTON_SIZE.LARGE}
                to={`/bok/${id}`}
              >
                Öppna
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

FeaturedBook.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  book: PropTypes.object,
  reversed: PropTypes.bool,
}

export default FeaturedBook
